import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index'
import Product from '@/components/product/product'
import ProDetails from '@/components/product/pro-details'
import News from '@/components/news/news'
import NewsDetails from '@/components/news/news-details'
import About from '@/components/about/about'
import Video from '@/components/video/video'
import VideoDetails from '@/components/video/video-details'
import Contact from '@/components/contact/contact'

Vue.use(Router)

export default new Router({
  routes: [
		{
			path: '/',
			name: 'Index',
			component: Index
		},
    {
    	path: '/index',
    	name: 'Index',
    	component: Index
    },
    {
    	path: '/product',
    	name: 'Product',
    	component: Product
    },
    {
    	path: '/pro-details',
    	name: 'ProDetails',
    	component: ProDetails
    },
    {
    	path: '/news',
    	name: 'News',
    	component: News
    },
    {
    	path: '/news-details',
    	name: 'NewsDetails',
    	component: NewsDetails
    },
    {
			path: '/about',
			name: 'About',
			component: About
		},
		{
			path: '/video',
			name: 'Video',
			component: Video
		},
    {
    	path: '/video-details',
    	name: 'VideoDetails',
    	component: VideoDetails
    },
    {
    	path: '/contact',
    	name: 'Contact',
    	component: Contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js